// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padTop{
  padding-top: 10%;
}

.padH1 {
  padding-top: 2%;
}

.form-control{
  box-shadow: none;
}





#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

mat-form-field {
  width: 250px;
}

.imageSize {
  width: 500px;
  height: 300px;
  position: fixed;
}

@media(max-width: 1000px) {
  .mobileHide {
    display: none;
  }
}
@media(min-width: 1000px) {
  .desktopHide {
    display: none;
  }
  /* input color class */
  input.mat-input-element {
    color: #ffe8bf;
  }
}
.center {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

::ng-deep.mat-form-field-underline {
  /*change color of underline*/
  background-color: orange !important;
}


`, "",{"version":3,"sources":["webpack://./src/app/login/login.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;;;;;AAMA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA,sBAAsB;EACtB;IACE,cAAc;EAChB;AACF;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC","sourcesContent":[".padTop{\n  padding-top: 10%;\n}\n\n.padH1 {\n  padding-top: 2%;\n}\n\n.form-control{\n  box-shadow: none;\n}\n\n\n\n\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\nmat-form-field {\n  width: 250px;\n}\n\n.imageSize {\n  width: 500px;\n  height: 300px;\n  position: fixed;\n}\n\n@media(max-width: 1000px) {\n  .mobileHide {\n    display: none;\n  }\n}\n@media(min-width: 1000px) {\n  .desktopHide {\n    display: none;\n  }\n  /* input color class */\n  input.mat-input-element {\n    color: #ffe8bf;\n  }\n}\n.center {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n::ng-deep.mat-form-field-underline {\n  /*change color of underline*/\n  background-color: orange !important;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
